import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface StripePaymentState{
    clientSecret:string | null;
    transactionRefId:string | null;
    orderDetail: any | null;
}

const initialState:StripePaymentState ={
    clientSecret:null,
    transactionRefId:null,
    orderDetail: null
}

export const StripePaymentSlice = createSlice({
    name:'stripePayment',
    initialState,
    reducers:{
        setPaymentDetail:(
            state,
            action:PayloadAction<{
                clientSecret:string | null;
                transactionRefId:string | null;
                orderDetail: {} | null;
            }>
        )=>{
            state.clientSecret= action.payload?.clientSecret;
            state.transactionRefId = action.payload?.transactionRefId
            state.orderDetail = action.payload;
        },
        resetPaymentDetail:(state)=>{
            state.clientSecret = null;
            state.transactionRefId= null;
            state.orderDetail = {};
            state =initialState;
        }
    }
})

export const {setPaymentDetail, resetPaymentDetail} = StripePaymentSlice.actions;
export const getClientSecret = (state: any) => state.stripePayment?.clientSecret;
export const getTransactionRefId = (state: any) => state.stripePayment?.transactionRefId;
export const getOrderDetail = (state: any) => state.stripePayment?.orderDetail;


export default StripePaymentSlice.reducer;